<div class="parent-wrapper">
  <div>
    <img src="assets/images/taly-dark-xm-logo.svg" alt="" />
    <h4 translate>CUSTOMER.ACCOUNT_CREATED</h4>
  </div>
</div>
